import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Field} from 'formik';
import styles from './styles.module.scss';

const FieldCheckbox = ({
                         fieldId,
                         label = null,
                         containerStyles = null,
                         onChange,
                         ...rest
                       }) => {
  const handleChange = (form, field) => event => {
    const value = event.target.checked;
    if (onChange) {
      onChange(value);
    }
    form.setFieldValue(field.name, value);
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({form, field, meta}) => (
        <label className={classnames(styles.inputContainer, containerStyles)}>
          <div className={styles.checkboxContainer}>
            <input
              className={classnames(styles.input)}
              type='checkbox'
              checked={field.value}
              onChange={handleChange(form, field)}
              {...rest}
            />
            <div className={classnames(styles.checkbox, {
              [styles.checked]: field.value,
              [styles.errorBorder]: meta.error && meta.touched
            })}/>
            <div className={styles.labelContainer}>
              {label}
            </div>
          </div>


        </label>
      )}
    </Field>
  )
};

FieldCheckbox.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  type: PropTypes.oneOf(['text', 'number', 'email', 'password', 'tel']),
  label: PropTypes.node,
  info: PropTypes.node,
  containerStyles: PropTypes.string,
  onChange: PropTypes.func,
};

export default FieldCheckbox;
